import global from '@/constants/GlobalConstant'
import _Vue from 'vue' // <-- notice the changed import

export interface Author {
    blog: string
    id: number
    name: string
    twitter: string
    web: string
}

const dictionary = {
    '0': `'Poppins', sans-serif`,
    '1': `'Roboto', sans-serif`,
    '2': `'Comic Sans MS', arial`,
    '3': `'Arial', fantasy`
}


export default function utilsPlugin(Vue: typeof _Vue, options?: any): void {
    Vue.prototype.$utils = {
        getFullName(user = { firstname: '', lastname: '' }) {
            if (user?.firstname && user?.lastname) {
                const { firstname, lastname } = user
                return `${this.upperFirstLetter(firstname.split(' ')[0])} ${this.upperFirstLetter(
                    lastname.split(' ')[0]
                )}`
            }
        },
        upperFirstLetter(word: string = '') {
            return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
        },
        capitalizeWord(word: string = '') {
            return `${word.charAt(0).toUpperCase()}${word.slice(1)}`
        },
        getFirstLetter(word: string = '') {
            if (word) return `${word.charAt(0).toUpperCase()}`
            return ''
        },
        pad(num: number, places: number = 0) {
            const zero = places - num.toString().length + 1
            return Array(+(zero > 0 && zero)).join('0') + num
        },
        postData(url = '', data = {}) {
            return new Promise((resolve, reject) => {
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                    .then((response) => resolve(response.json()))
                    .catch(reject)
            })
        },
        divideArrayInEqualsParts(arr: Array<any>, parts: number) {
            return new Array(Math.ceil(arr.length / parts))
                .fill([])
                .map((_) => arr.splice(0, parts))
        },
        getAuthorName(author: Author | any, authorList: Array<Author | any> = [], $t: any, defaultName = 'Anonymous') {
            return authorList && authorList.length
                ? authorList.map(({ name }) => name).join(', ')
                : author
                ? author.name
                : defaultName
        },
        fontFamilyDictionary(fontKey: '0'){
            return dictionary[fontKey]
        },
        globalConstants: global,
    }
}
